module.exports = __webpack_public_path__ + "static/media/TransferenciaImovel.d9cc2599.bin";